// extracted by mini-css-extract-plugin
module.exports = {"controls":"styles_controls__vnBx4","zoomReset":"styles_zoomReset__hVRJI"};